import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";

const PatientRegister = () => {
  const navigate = useNavigate();

  const invitedEmail = sessionStorage.getItem("inviteEmail");
  const inviteSessionToken = sessionStorage.getItem("inviteSessionToken");

  const [email] = useState(invitedEmail || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* ======================
     INVITE GUARD
  ====================== */
  useEffect(() => {
    if (!invitedEmail || !inviteSessionToken) {
      navigate("/patientlogin");
    }
  }, [invitedEmail, inviteSessionToken, navigate]);

  /* ======================
     REGISTER
  ====================== */
  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await axios.post(
        `${config.API_BASE_URL}${config.PATIENT.REGISTER}`,
        {
          email,
          password,
          inviteSessionToken
        }
      );

      // Clear invite context
      sessionStorage.removeItem("inviteEmail");
      sessionStorage.removeItem("inviteRole");
      sessionStorage.removeItem("inviteSessionToken");

      navigate("/patientlogin");

    } catch (err) {
      setError(err.response?.data?.error || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={container}>
      <div style={card}>
        <h2 style={title}>Create User Account</h2>
        <p style={subtitle}>Invitation Verified</p>

        {error && <p style={errorText}>{error}</p>}

        <form onSubmit={handleRegister}>
          <div style={inputGroup}>
            <label style={labelStyle}>Email Address</label>
            <input
              type="email"
              value={email}
              disabled
              style={{ ...input, background: "#f1f3f5" }}
            />
          </div>

          <div style={inputGroup}>
            <label style={labelStyle}>Password</label>
            <input
              type="password"
              required
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={input}
            />
          </div>

          <button
            type="submit"
            style={primaryBtn}
            disabled={loading}
          >
            {loading ? "Creating account..." : "Register"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PatientRegister;


/* =====================
   STYLES (MATCHES ACCEPT INVITE)
===================== */

const container = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #eef2f7, #f9fbfd)"
};

const card = {
  background: "#fff",
  padding: "36px",
  width: "420px",
  textAlign: "center",
  borderRadius: "14px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.12)"
};

const title = {
  color: "#0E5580",
  marginBottom: "6px"
};

const subtitle = {
  color: "#666",
  marginBottom: "24px",
  fontSize: "14px"
};

const inputGroup = {
  display: "flex",
  flexDirection: "column",
  marginBottom: "16px",
  textAlign: "left"
};

const labelStyle = {
  fontSize: "13px",
  marginBottom: "6px",
  color: "#444"
};

const input = {
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #ddd",
  fontSize: "14px"
};

const primaryBtn = {
  width: "100%",
  padding: "12px",
  background: "#0E5580",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  marginTop: "6px"
};

const errorText = {
  color: "#c0392b",
  marginBottom: "16px"
};
